import { createHooks } from 'hookable';

export interface ApplicationHooks {
	'app::init': () => void;
	'auth::login': () => void;
	'query-client::error': (error: any) => void;
}

export const hooks = createHooks<ApplicationHooks>();
